export default "/static/5560077e3f961622.svg"